"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * NWG.Commerce.Microshop - Api
 * NWG.Commerce.Microshop - Api functionality
 *
 * The version of the OpenAPI document: NWG.Commerce.Microshop - Api
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.SocialLinkToJSON = exports.SocialLinkFromJSONTyped = exports.SocialLinkFromJSON = exports.instanceOfSocialLink = void 0;
var runtime_1 = require("../runtime");
/**
 * Check if a given object implements the SocialLink interface.
 */
function instanceOfSocialLink(value) {
    var isInstance = true;
    return isInstance;
}
exports.instanceOfSocialLink = instanceOfSocialLink;
function SocialLinkFromJSON(json) {
    return SocialLinkFromJSONTyped(json, false);
}
exports.SocialLinkFromJSON = SocialLinkFromJSON;
function SocialLinkFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'icon': !(0, runtime_1.exists)(json, 'icon') ? undefined : json['icon'],
        'url': !(0, runtime_1.exists)(json, 'url') ? undefined : json['url'],
    };
}
exports.SocialLinkFromJSONTyped = SocialLinkFromJSONTyped;
function SocialLinkToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'icon': value.icon,
        'url': value.url,
    };
}
exports.SocialLinkToJSON = SocialLinkToJSON;
